import { useEffect, useState, useMemo } from 'react';
import {
    Button, Card, Stack,
    Table,
    TableBody,
    TableCell, TableRow, Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getRequest, postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { paths } from 'src/routes/paths';
import Iconify from 'src/components/iconify';
import { useLocation, useNavigate } from 'react-router';
import PlansCreateCards from './plans-create-form-cards';

export const PlanAddonViewPage = ({ open, onClose, reload, currentItem, closeform, }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);
    const navigate = useNavigate();

    const location = useLocation();
    const row = location.state;
    console.log("modules.....>>>>>>>>>>>>>>>>>>>", row);

    const [ newmodules, setModules ] = useState([]);
    console.log("🚀 ~ PlanAddonViewPage ~ newmodules:", newmodules)

    const NewDocumentSchema = Yup.object().shape({
    });

    useEffect(() => {
        getPlansViewDetails();
    }, []);
    const getPlansViewDetails = async () => {
        setLoading(true)

        const data = await getRequest(`${endpoints.admin_dashboard.packages_plans.plans.show_plans}/${row?.id}`);
        if (data) {
            setModules(data || []);
        }
        setLoading(false)

    };

    const defaultValues = useMemo(
        () => ({

            code: currentItem?.code || '',
            description: currentItem?.description || '',

        }),
        [ currentItem ]
    );

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('code', data.code);
        formData.append('description', data.description);
        try {
            const response = await postRequest(
                currentItem?.id
                    ? `${endpoints.admin_dashboard.teachnical_database.cost_codes.post_list}/${currentItem.id}?_method=PUT`
                    : endpoints.admin_dashboard.teachnical_database.cost_codes.post_list,
                formData,
                true
            );

            if (response.metadata?.success) {
                reset();
                onClose();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });


    return (<>
        <Card
            sx={ {
                padding: "20px",
                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'

            } }

        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <CustomBreadcrumbs
                    heading="Product / Packages Plan
"
                    links={ [ { name: '', href: paths.dashboard.root } ] }
                    action={
                        <Button
                            onClick={ () => navigate("/dashboard/product-packages/plans") }
                            variant="contained"
                            startIcon={ <Iconify icon="material-symbols:arrow-back-ios-rounded" /> }
                        >
                            Back
                        </Button>
                    }
                    sx={ {
                        mb: { xs: 3, md: 2 },
                    } }
                />

                <Typography variant="subtitle1" fontWeight="600" mb={ 2 }>
                    PRODUCT PACKAGES PLAN
                </Typography>

                <Table>
                    <TableBody>
                        <TableRow sx={ { backgroundColor: "#f1f5f9" } }>
                            <TableCell sx={ { fontWeight: 700 } }>Plan Name</TableCell>
                            <TableCell>{ newmodules?.plan_name }</TableCell>
                            <TableCell sx={ { fontWeight: 700 } }>Trial Days</TableCell>
                            <TableCell>{ newmodules?.total_trial_days }</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell sx={ { fontWeight: 700 } }>Discount%</TableCell>
                            <TableCell>{ newmodules?.discount_percentage }</TableCell>
                            <TableCell sx={ { fontWeight: 700 } }>Fixed Setup Cost</TableCell>
                            <TableCell>${ newmodules?.fixed_setup_cost }</TableCell>
                        </TableRow>

                        <TableRow sx={ { backgroundColor: "#f1f5f9" } }>
                            <TableCell sx={ { fontWeight: 700 } }>Total Plan Cost</TableCell>
                            <TableCell>${ newmodules?.total_plan_cost }</TableCell>
                            <TableCell sx={ { fontWeight: 700 } }>Description</TableCell>
                            <TableCell>{ newmodules?.description }</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                {/* </Box> */ }

            </FormProvider>
        </Card>
        <Stack
            sx={ {
                padding: "20px",
                borderRadius: "5px",
                marginTop: "20px",
            } }
        >
            <Typography variant="h6">
                { "Plan Features & Add on Features" }
            </Typography>
        </Stack>

        { newmodules?.product_modules?.map((module, index) =>
        (
            <PlansCreateCards
                module_name={ "Plan Add on Features" }
                plan_name={ module?.module_name }
                features={ module?.feature_list }
                view={ "view" }


            />))
        }
    </>
    );
};